import AbstractController from '../src/services/ControllersRepository/AbstractController';
import TechOperationsCreateForm from '@views/tech-operations/TechOperationsCreateForm';
import TechOperationsUpdateForm from '@views/tech-operations/TechOperationsUpdateForm';

export default class TechOperations extends AbstractController {
    protected controllerName = 'TechOperations';

    protected getDefaultCreateFormComponent() {
        return TechOperationsCreateForm;
    }

    protected getDefaultUpdateFormComponent() {
        return TechOperationsUpdateForm;
    }
}
